import React from 'react';
export var Clock = function (_a) {
    var fillColor = _a.fillColor;
    return React.createElement(React.Fragment, null,
        " ",
        React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
            React.createElement("circle", { cx: "16", cy: "16", r: "12", fill: fillColor }),
            React.createElement("path", { d: "M17 7a1 1 0 1 0-2 0v8a2 2 0 0 0 2 2h6a1 1 0 1 0 0-2h-6V7Z", fill: 'currentColor' }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2ZM4 16C4 9.373 9.373 4 16 4s12 5.373 12 12-5.373 12-12 12S4 22.627 4 16Z", fill: 'currentColor' })));
};
export default Clock;
